<script lang="ts">
export let color = "#1A1A1C";
export let size = 24;
</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
  <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" fill={color} />
</svg>